module.exports = __webpack_public_path__ + "img/logo-vtexio.af219bb0.svg";